package navigation.settings.tags.alltags

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.tag.domain.repository.TagRepository
import com.essntl.features.tag.ui.alltags.AllTagsEvent
import com.essntl.features.tag.ui.alltags.AllTagsState
import com.essntl.features.tag.ui.alltags.AllTagsViewModel

class AllTagsScreenModel(
    tagRepository: TagRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllTagsState>(AllTagsState()) {

    private val viewModel =
        AllTagsViewModel(
            tagRepository = tagRepository,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllTagsEvent) = viewModel.onEvent(event)
}